import styled from 'styled-components';
import AppCSS from '../../../utils/styled';

export const Components = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    width: 100%;
  `,
  TextFieldContainer: styled.div`
    width: 100%;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.white};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `,
  SecureIconWrapper: styled.div<{ isPressable?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    padding: 4px;
    margin-right: 4px;
    ${({ isPressable }) => isPressable && 'cursor: pointer;'};
  `,
  TextField: styled.input<{ cursor?: string }>`
    flex: 1;
    width: 100%;
    padding: 12px;
    height: 38px;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.black};
    background-color: transparent;
    border: none;
    -webkit-appearance: none;
    ${({ cursor }) => cursor && `cursor: ${cursor};`};
    &:focus-visible {
      -webkit-appearance: none;
      border: none;
      outline: none;
    }
    &:focus {
      -webkit-appearance: none;
      border: none;
      outline: none;
    }
    &::placeholder {
      color: ${AppCSS.colors.greys.prettyDark};
    }
  `,
  ErrorMessage: styled.span`
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.red};
  `,
};
